// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2019 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-channel-dimensions-widget-dim {
  display: contents;
}

.neuroglancer-channel-dimensions-widget {
  display: grid;
  grid-template-columns: [name] min-content [lower] min-content [upper] min-content;
}

.neuroglancer-channel-dimensions-widget-name-container {
  grid-column: name;
}

.neuroglancer-channel-dimensions-widget-name[data-is-valid="false"],
.neuroglancer-channel-dimensions-widget-name::placeholder {
  text-decoration: solid underline red;
}

.neuroglancer-channel-dimensions-widget-name {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  border: 0;
  margin: 0;
  font-family: monospace;
  font-size: medium;
  color: #ff6;
}

.neuroglancer-channel-dimensions-widget-name,
.neuroglancer-channel-dimensions-widget-lower,
.neuroglancer-channel-dimensions-widget-upper {
  font-family: monospace;
}

.neuroglancer-channel-dimensions-widget-lower {
  grid-column: lower;
  text-align: right;
}

.neuroglancer-channel-dimensions-widget-upper {
  grid-column: upper;
  text-align: right;
}

.neuroglancer-channel-dimensions-widget-lower,
.neuroglancer-channel-dimensions-widget-upper {
  text-align: right;
  margin-left: 1ch;
  user-select: text;
}

.neuroglancer-channel-dimensions-widget-upper::after {
  content: ")";
}

.neuroglancer-channel-dimensions-widget-lower::after {
  content: ",";
}

.neuroglancer-channel-dimensions-widget-lower::before {
  content: "[";
}

.neuroglancer-channel-dimensions-widget-upper::after,
.neuroglancer-channel-dimensions-widget-lower::before,
.neuroglancer-channel-dimensions-widget-lower::after {
  color: #999;
}
`, "",{"version":3,"sources":["webpack://./node_modules/neuroglancer/lib/widget/channel_dimensions_widget.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,WAAW;AACb","sourcesContent":["/**\n * @license\n * Copyright 2019 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-channel-dimensions-widget-dim {\n  display: contents;\n}\n\n.neuroglancer-channel-dimensions-widget {\n  display: grid;\n  grid-template-columns: [name] min-content [lower] min-content [upper] min-content;\n}\n\n.neuroglancer-channel-dimensions-widget-name-container {\n  grid-column: name;\n}\n\n.neuroglancer-channel-dimensions-widget-name[data-is-valid=\"false\"],\n.neuroglancer-channel-dimensions-widget-name::placeholder {\n  text-decoration: solid underline red;\n}\n\n.neuroglancer-channel-dimensions-widget-name {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n  border: 0;\n  margin: 0;\n  font-family: monospace;\n  font-size: medium;\n  color: #ff6;\n}\n\n.neuroglancer-channel-dimensions-widget-name,\n.neuroglancer-channel-dimensions-widget-lower,\n.neuroglancer-channel-dimensions-widget-upper {\n  font-family: monospace;\n}\n\n.neuroglancer-channel-dimensions-widget-lower {\n  grid-column: lower;\n  text-align: right;\n}\n\n.neuroglancer-channel-dimensions-widget-upper {\n  grid-column: upper;\n  text-align: right;\n}\n\n.neuroglancer-channel-dimensions-widget-lower,\n.neuroglancer-channel-dimensions-widget-upper {\n  text-align: right;\n  margin-left: 1ch;\n  user-select: text;\n}\n\n.neuroglancer-channel-dimensions-widget-upper::after {\n  content: \")\";\n}\n\n.neuroglancer-channel-dimensions-widget-lower::after {\n  content: \",\";\n}\n\n.neuroglancer-channel-dimensions-widget-lower::before {\n  content: \"[\";\n}\n\n.neuroglancer-channel-dimensions-widget-upper::after,\n.neuroglancer-channel-dimensions-widget-lower::before,\n.neuroglancer-channel-dimensions-widget-lower::after {\n  color: #999;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
